import { Exception } from '../Exception';

export class MeetingAlreadySavedException extends Exception {
  constructor() {
    super();
  }
}
